import { create } from "zustand";

export interface MaterialUsage {
  name: string;
  used: number;
  total: number;
  unit: string;
}

export interface DashboardData {
  activeFlags: number;
  processing: { stage: string; level: string; progress: number };
  materials: MaterialUsage[];
}

const BASE: DashboardData = {
  activeFlags: 2,
  processing: { stage: "Live Plan Processing", level: "Level 2 Structural Elements", progress: 0.64 },
  materials: [
    { name: "Concrete", used: 142, total: 210, unit: "m³" },
    { name: "Steel", used: 8.4, total: 12, unit: "t" },
    { name: "Brick", used: 31000, total: 48000, unit: "units" },
    { name: "Timber", used: 2.1, total: 6.5, unit: "m³" },
    { name: "Roofing", used: 0, total: 320, unit: "m²" },
    { name: "Glazing", used: 0, total: 96, unit: "m²" },
  ],
};

interface DashboardState {
  byProject: Record<string, DashboardData>;
  getForProject: (projectId: string) => DashboardData;
}

export const useDashboardStore = create<DashboardState>((set, get) => ({
  byProject: {},
  getForProject: (projectId) => {
    const existing = get().byProject[projectId];
    if (existing) return existing;
    const data: DashboardData = { ...BASE };
    set((s) => ({ byProject: { ...s.byProject, [projectId]: data } }));
    return data;
  },
}));

export const formatZAR = (n: number) => `R ${n.toLocaleString("en-ZA").replace(/,/g, " ")}`;
